export function bindTurboBeforeCacheEvents() {
  document.addEventListener('turbo:before-cache', () => {
    document.querySelectorAll('dialog[open]').forEach(d => d.close());
  });
}

export function bindTurboLoadEvents() {
  document.addEventListener('turbo:load', function() {
    if (!window.fathom) return;
    window.fathom.trackPageview();
  });
}
